import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography, Button } from 'antd';

import useStyles from './style';
import ComposeLinkInput from './composeLinkInput';
import { Plus as IconPlus } from 'common/components/svgs';

const MAX_LINK_NUM = 10;

const VettingDocumentCard = ({
  form,
  type,
  title,
  emptyText,
  dataSource,
  handleAddLink,
  handleRemoveLink,
  handleInputChange,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleRemoveClick = index => {
    handleRemoveLink(type, index);
  };

  const handleChange = (idx, field, value) => {
    handleInputChange(type, idx, field, value);
  };

  return (
    <Row>
      <Col span={24} className={classes.cardHeader}>
        <Typography.Text>{title}</Typography.Text>
      </Col>
      <Col span={24} className={classes.formSection}>
        <Choose>
          <When condition={dataSource?.length > 0}>
            <Row className={classes.formHeader}>
              <Col className={classes.formLeft}></Col>
              <Col className={classes.formMiddle}>
                <Typography.Text>
                  {t('cms.landlord.verification.label.link_address')}
                </Typography.Text>
                <Typography.Text>
                  {t('cms.landlord.verification.notice.link_limit')}
                </Typography.Text>
              </Col>
              <Col className={classes.formRight}>
                <Typography.Text>{t('cms.landlord.verification.label.note')}</Typography.Text>
              </Col>
            </Row>

            <div className={classes.formMain}>
              <For each="item" index="idx" of={dataSource}>
                <ComposeLinkInput
                  key={idx}
                  index={idx}
                  value={item}
                  form={form}
                  type={type}
                  handleRemoveClick={() => handleRemoveClick(idx)}
                  handleInputChange={(field, value) => handleChange(idx, field, value)}
                />
              </For>
            </div>

            <If condition={dataSource.length < MAX_LINK_NUM}>
              <Button
                type={'link'}
                className={classes.addButton}
                onClick={() => handleAddLink(type)}
              >
                {t('cms.landlord.verification.button.add_another_link')}
              </Button>
            </If>
          </When>
          <Otherwise>
            <div className={classes.emptyText}>
              <Typography.Text>{t(emptyText)}</Typography.Text>

              <Button type="link" onClick={() => handleAddLink(type)}>
                <span className="anticon">
                  <IconPlus />
                </span>
                {t('cms.landlord.verification.button.add_link_now')}
              </Button>
            </div>
          </Otherwise>
        </Choose>
      </Col>
    </Row>
  );
};

VettingDocumentCard.propTypes = {
  form: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  emptyText: PropTypes.string.isRequired,
  dataSource: PropTypes.array.isRequired,
  handleAddLink: PropTypes.func.isRequired,
  handleRemoveLink: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default VettingDocumentCard;
